import { zafClient, zaf, zendeskApi } from '@/features/zendesk-app'
import { ZendeskRoutes } from '@/config/routes'
import urlcat from 'urlcat'

export const zendeskFetch = <T>(url: string, options?: Partial<zaf.RequestOptions>): Promise<T> =>
  zafClient!.request<T>({
    url: `/api/v2/${url.startsWith('/') ? url.replace('/', '') : url}`,
    contentType: 'application/json',
    ...options,
  })

export const zendeskPostFetch = <T>(url: string, data: object): Promise<T> =>
  zendeskFetch<T>(url, {
    data: JSON.stringify(data),
    type: 'POST',
  })

export const getWebhooks = () => zendeskFetch<{ webhooks: zendeskApi.Webhook[] }>(ZendeskRoutes.getWebhooks)
export const createWebhook = (webhook: Partial<zendeskApi.Webhook>) =>
  zendeskPostFetch<{ webhook: zendeskApi.Webhook }>(ZendeskRoutes.createWebhook, { webhook })

export const getTriggerCategories = () =>
  zendeskFetch<zendeskApi.Paginated<{ trigger_categories: zendeskApi.TriggerCategory[] }>>(
    ZendeskRoutes.getTriggerCategories
  )

export const createTriggerCategory = (trigger_category: Partial<zendeskApi.TriggerCategory>) =>
  zendeskPostFetch<{ trigger_category: zendeskApi.TriggerCategory }>(ZendeskRoutes.createTriggerCategory, {
    trigger_category,
  })

export const getTriggers = (categoryId: string) =>
  zendeskFetch<{ triggers: zendeskApi.Trigger[] }>(
    urlcat(ZendeskRoutes.getTriggers, { category_id: categoryId, sort_by: 'updated_at' })
  )

export const createTrigger = (trigger: Partial<zendeskApi.Trigger>) =>
  zendeskPostFetch<{ trigger: zendeskApi.Trigger }>(ZendeskRoutes.createTrigger, { trigger })

export const getCustomObjects = () =>
  zendeskFetch<zendeskApi.PagePaginated<{ custom_objects: zendeskApi.CustomObject[] }>>(ZendeskRoutes.getCustomObjects)

export const getCustomObjectFields = (customObjectKey: string) =>
  zendeskFetch<zendeskApi.PagePaginated<{ custom_object_fields: zendeskApi.CustomObjectField[] }>>(
    urlcat(ZendeskRoutes.getCustomObjectFields, { customObjectKey })
  )

export const getZendeskFields = () =>
  zendeskFetch<zendeskApi.PagePaginated<{ ticket_fields: zendeskApi.TicketField[] }>>(ZendeskRoutes.getTicketFields)

export const getViews = () =>
  zendeskFetch<zendeskApi.PagePaginated<{ views: zendeskApi.View[] }>>(ZendeskRoutes.getViews)
